module.exports = __webpack_public_path__ + "static/flutterwave-webhook-dashboard-578c2e002c5cd31ddd85c052916797a5.png";